<script>
import options from './StreamDonationOverview.options'
import StreamDonationOverviewNewDonation from '../StreamDonationOverviewNewDonation/StreamDonationOverviewNewDonation.vue'
import StreamDonationOverviewPreviousDonation from '../StreamDonationOverviewPreviousDonation/StreamDonationOverviewPreviousDonation.vue'
export default {
  ...options,
  components: { StreamDonationOverviewNewDonation, StreamDonationOverviewPreviousDonation }
}
</script>

<template>
  <div class="kb-stream-donation-overview-wrapper">
    <div v-if="donationPosition === 'above'" class="kb-stream-donation-overview-donations kb-stream-donation-overview-donations--above">
      <template v-for="i in [3, 2, 1, 0]" :key="i">
        <StreamDonationOverviewPreviousDonation v-if="previousDonations[i]" :key="previousDonations[i].id" :variation="variation" :donation-style="donationStyle" :index="i" :amount="previousDonations[i].amount" :donor-name="previousDonations[i].donorName" />
      </template>
      <StreamDonationOverviewNewDonation v-if="currentNew" :key="currentNew.id" :donation-style="donationStyle" :amount="currentNew.amount" :donor-name="currentNew.donorName" />
    </div>

    <article class="kb-stream-donation-overview" :class="`kb-stream-donation-overview--${variation}`">
      <h2 class="kb-stream-donation-overview__title">{{ name }}</h2>

      <div class="kb-stream-donation-overview__row">
        <span class="kb-stream-donation-overview__raised">{{ totalAmount }} kr.</span>
        <span class="kb-stream-donation-overview__goal">
          <span class="kb-stream-donation-overview__goal-label">Mål: </span>
          <span class="kb-stream-donation-overview__goal-value">{{ targetAmount }} kr.</span>
        </span>
      </div>

      <div class="kb-stream-donation-overview__progress">
        <div class="kb-stream-donation-overview__progress-fill" :style="`width: ${progressPercent}%;`"></div>
      </div>

      <p class="kb-stream-donation-overview__footer" v-html="footerText"></p>
    </article>

    <div v-if="donationPosition === 'below'" class="kb-stream-donation-overview-donations kb-stream-donation-overview-donations--below">
      <StreamDonationOverviewNewDonation v-if="currentNew" :key="currentNew.id" :donation-style="donationStyle" :amount="currentNew.amount" :donor-name="currentNew.donorName" />
      <template v-for="i in [0, 1, 2, 3]" :key="i">
        <StreamDonationOverviewPreviousDonation v-if="previousDonations[i]" :key="previousDonations[i].id" :variation="variation" :donation-style="donationStyle" :index="i" :amount="previousDonations[i].amount" :donor-name="previousDonations[i].donorName" />
      </template>
    </div>
  </div>
</template>
